import {Splide} from "@splidejs/splide";

// hero sider
const sliderWhy = document.getElementById("whySlider");
if (sliderWhy) {
    new Splide(sliderWhy,
        {
            type   : 'loop',
            arrows: false,
            perPage: 1,
            pagination:true,     
            autoplay: false,
            interval: 3500, 
            speed: 2000,
        }
    ).mount({   }); 
}

// Reviews sider
const sliderPartners = document.getElementById("partnerSlider");
if (sliderPartners) {
    new Splide(sliderPartners,
        {
            type   : 'loop',
            arrows: true,
            pagination:false,
            perPage: 5,
            autoplay: true,
            interval: 3500, 
            speed: 2000,

            breakpoints: {
                640: {
                    perPage: 3,
                }
            }

        }
    ).mount({   }); 
}

// Reviews sider
const sliderReviews = document.getElementById("reviewsSlider");
if (sliderReviews) {
    new Splide(sliderReviews,
        {
            type   : 'loop',
            arrows: true,
            pagination:true,
            perPage: 3,
            autoplay: true,
            interval: 3500, 
            speed: 2000,

            breakpoints: {
                640: {
                    perPage: 1,
                }
            }

        }
    ).mount({   }); 
}

